import css from 'styled-jsx/css';

const styles = css.global`#seguro-auto-facilidades {
    background: #DEEDF2;
    overflow: hidden;
    padding-bottom: 40px;
}

#seguro-auto-facilidades .ctn-home-24 {
    display: flex;
    flex-direction: column;
    gap: 56px;
}

#seguro-auto-facilidades .facilidades-contain-1 {
    display: flex;
    flex-direction: column;
    gap: 32px;
}

#seguro-auto-facilidades .facilidades-titulo {
    color: #444;
    font-family: "SantanderHeadline";
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 36px; 
}

#seguro-auto-facilidades .carrossel-facilidades-1 .slide,
#seguro-auto-facilidades .cards-facilidades .card-facilidades {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
    width: 250px;
    margin-right: 16px;
    flex: 0 0 250px;
}

#seguro-auto-facilidades .carrossel-facilidades-1 .slide.slide-menor {
    width: 203px;
    flex: 0 0 203px;
}

#seguro-auto-facilidades .carrossel-facilidades-1 .slide .carrossel-facilidades-1-texto,
#seguro-auto-facilidades .cards-facilidades .card-facilidades .carrossel-facilidades-1-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#seguro-auto-facilidades .carrossel-facilidades-1 .home-pagination,
#seguro-auto-facilidades .carrossel-facilidades-2 .home-pagination {
    margin-top: 24px;
}

#seguro-auto-facilidades .carrossel-facilidades-1 .home-pagination .embla__prev, 
#seguro-auto-facilidades .carrossel-facilidades-1 .home-pagination .embla__next,
#seguro-auto-facilidades .carrossel-facilidades-2 .home-pagination .embla__prev, 
#seguro-auto-facilidades .carrossel-facilidades-2 .home-pagination .embla__next {
    width: 24px;
    height: 24px;
    background-size: 24px 24px;
}

#seguro-auto-facilidades .carrossel-facilidades-1 .home-pagination .embla__prev {
    background-image: url(assets/seguro-auto-25/facilidades/ic_arrow_red_l.svg);
}

#seguro-auto-facilidades .carrossel-facilidades-1 .home-pagination .embla__next {
    background-image: url(assets/seguro-auto-25/facilidades/ic_arrow_red_r.svg);
}


#seguro-auto-facilidades .carrossel-facilidades-2 .slide {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 32px;
    width: 94%;
    margin-right: 8px;
    flex: 0 0 94%;
    border-radius: 4px;
    background: #CEDEE7;
    padding: 32px 24px;
    justify-content: space-between;
}

#seguro-auto-facilidades .carrossel-facilidades-2 .slide .carrossel-facilidades-2-texto {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#seguro-auto-facilidades .carrossel-facilidades-2 .slide .carrossel-facilidades-2-texto b {
    font-weight: 600;
}

#seguro-auto-facilidades .carrossel-facilidades-2 .slide .carrossel-facilidades-2-link {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    height: 48px;
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px; /* 155.556% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    cursor: pointer;
}

#seguro-auto-facilidades .carrossel-facilidades-2 .logo-santander-auto {
    width: 230px;
}

html.scroll-disabled {
    overflow: hidden !important;
}

.modal-canais-contato {
    width: 100%;
    height: 100vh;
    background-color: rgba(34, 34, 34, 0.6);
    position: fixed;
    z-index: 9999999;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 10px;
    overflow-y: scroll;
}

.modal-canais-contato .modal {
    position: relative;
    background: #fff;
    padding: 18px 16px 0 16px;
    border-radius: 4px;
    border: 1px solid #CCC;
    box-shadow: 0px 2px 16px -2px rgba(34, 34, 34, 0.40);
    width: 100%;
    max-width: 800px;
    height: calc(100vh - 20px);
    max-height: 600px;
    min-height: 590px;
    z-index: 10000;
}

#modal-canais-contato-zurich.modal-canais-contato .modal {
    height: 398px;
    max-height: 398px;
    min-height: 398px;
}

.modal-canais-contato .modal .close-modal {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
}

.modal-canais-contato .modal .modal-canais-contato-titulo {
    display: flex;
    align-items: center;
    gap: 8px;
}

.modal-canais-contato .modal .modal-canais-contato-titulo p {
    color: #222;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

#modal-canais-contato-santander.modal-canais-contato .modal-canais-contato-contatos {
    overflow-y: scroll;
    height: 534px;
    padding-bottom: 30px;
}

.modal-canais-contato .modal-canais-contato-contatos {
    margin-top: 18px;
    padding: 0 27px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    gap: 32px;
}

.modal-canais-contato .bloco-contato,
.modal-canais-contato .bloco-contato-texto {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.modal-canais-contato .bloco-contato,
.modal-canais-contato .bloco-contato a {
    color: #222;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
}

.modal-canais-contato .bloco-contato .bloco-contato-titulo {
    color: #C00;
    font-weight: 600;
}

.modal-canais-contato .bloco-contato .bloco-contato-telefones {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.modal-canais-contato .bloco-contato .contato-link-tel {
    font-weight: 600;
}

.modal-canais-contato .bloco-contato .contato-link-tel:hover {
    color: #C00;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
}

.modal-canais-contato .bloco-contato .contato-link {
    color: #C00;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    display: inline-block;
}

@media (min-width: 992px) {
    #seguro-auto-facilidades {
        padding-bottom: 88px;
    }

    #seguro-auto-facilidades .ctn-home-24 {
        gap: 60px;
    }

    #seguro-auto-facilidades .facilidades-contain-1 {
        flex-direction: row;
        gap: 56px;
    }

    #seguro-auto-facilidades .facilidades-titulo {
        font-size: 56px;
        line-height: 120%; 
        width: 50%;
    }

    #seguro-auto-facilidades .cards-facilidades {
        display: flex;
        flex-wrap: wrap;
        width: 50%;
        min-width: 507px;
        gap: 32px 7px;
    }

    #seguro-auto-facilidades .cards-facilidades .card-facilidades {
        margin-right: 0;
    }

    #seguro-auto-facilidades .carrossel-facilidades-2 .slide {
        width: calc(50% - 20px);
        max-width: 582px;
        flex: 0 0 calc(50% - 20px);
        justify-content: first baseline;
        margin-right: 40px;
    }

    #seguro-auto-facilidades .carrossel-facilidades-2 .home-pagination {
        display: none;
    }
}`;

export default styles;